import { getLabel } from "../../hooks/use-labels";

export const PRIMARY_NAV = [
  { key: "home", label: "Home", path: "/" },
  { key: "accessories", label: "Accessories", path: "/accessories" },
  { key: "my-orders", label: "My Orders", path: "/my-orders", auth: true },
];

export const accountNav = () => [
  { key: "finance", label: getLabel("financeLabel"), path: "/finance" },
  { key: "saved-suppliers", label: "Saved Suppliers", path: "/saved-suppliers" },
  { key: "withdrawal", label: getLabel("withdrawalLabel"), path: "/finance/withdrawals" },
  // { key: "saved-accounts", label: getLabel("savedCardLabel"), path: "/saved-accounts" },
  { key: "myreviews", label: getLabel("myReviewsLabel"), path: "/my-reviews" },
  { key: "faqs", label: getLabel("faqLabel"), path: "/faqs" },
  { key: "privacyPolicy", label: getLabel("privacyLabel"), path: "/privacy" },
  { key: "terms", label: getLabel("termsLabel"), path: "/terms" },
  { key: "accountsettings", label: getLabel("accountSettingsLabel"), path: "/account-settings" },
  { key: "logout", label: "Logout", action: "logout" },
];

export const PROFILE_PATH = "/account-settings";

const matchesItem = (item, pathname) => {
  if (!item.path) return false;
  if (item.path === "/") return pathname === "/";
  return pathname === item.path || pathname.startsWith(`${item.path}/`);
};

export const isNavActive = (item, pathname, items = []) => {
  if (!matchesItem(item, pathname)) return false;

  const bestMatch = items
    .filter((candidate) => matchesItem(candidate, pathname))
    .reduce((best, candidate) =>
      !best || candidate.path.length > best.path.length ? candidate : best,
    null);

  return bestMatch ? bestMatch.key === item.key : true;
};
